// extracted by mini-css-extract-plugin
module.exports = {"container":"_a5acafb","avatar":"_772808d","label":"_f5ada41","deposit":"_cbf87c1","authWrapper":"_a5f4574"};